import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AuthBlock from "./AuthBlock";
import ThemeSelector from "./ThemeSelector";
import { useAuth } from "../modules/auth/context/AuthContext";
import PbxStatusIndicator from "./Telephony/PbxStatusIndicator";
import { useIsTabletOrBelow } from "../hooks/useMediaQuery";
import {
  HeaderStyle,
  HeaderInner,
  LogoLink,
  LogoImg,
  LogoText,
  StyledLink,
  EnvBadge,
  NavLinks,
  BurgerButton,
  MobileNavPanel,
  MobileNavLink,
} from "./Header.module";

const Header = () => {
  const { user, apps } = useAuth();
  const isAdmin = user?.globalRole === "ADMIN";
  const isTabletOrBelow = useIsTabletOrBelow();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isTabletOrBelow) setIsMenuOpen(false);
  }, [isTabletOrBelow]);

  useEffect(() => {
    if (!isMenuOpen) return;
    const handler = (e) => {
      if (e.key === "Escape") setIsMenuOpen(false);
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [isMenuOpen]);

  const showWarehouse = isAdmin || apps.some((a) => a.slug === "warehouse");
  const showShipments = isAdmin || apps.some((a) => a.slug === "shipments");
  const showPhoneExpenses = isAdmin || apps.some((a) => a.slug === "phone_expenses");
  const showPayments = isAdmin || apps.some((a) => a.slug === "payments");
  const showTelephony = isAdmin || apps.some((a) => a.slug === "telephony");

  return (
    <HeaderStyle>
      {process.env.REACT_APP_ENV === 'demo' && <EnvBadge>Demo</EnvBadge>}
      <HeaderInner>
        <LogoLink to="/">
          <LogoImg src="/logo.png" alt="SPARK" />
          <LogoText>SPARK</LogoText>
        </LogoLink>
        <NavLinks>
          <StyledLink to="/">Home</StyledLink>
          {showWarehouse && <StyledLink to="/warehouse">Склад</StyledLink>}
          {showShipments && <StyledLink to="/shipments">Відправлення</StyledLink>}
          {showPhoneExpenses && <StyledLink to="/phone-expenses">Связь</StyledLink>}
          {showPayments && <StyledLink to="/payments">Платежі</StyledLink>}
          {showTelephony && <StyledLink to="/telephony">Продажі</StyledLink>}
        </NavLinks>
        <PbxStatusIndicator />
        <AuthBlock />
        <BurgerButton
          type="button"
          onClick={() => setIsMenuOpen((v) => !v)}
          aria-label={isMenuOpen ? "Закрити меню" : "Відкрити меню"}
          aria-expanded={isMenuOpen}
        >
          <span style={isMenuOpen ? { transform: "translateY(6px) rotate(45deg)" } : undefined} />
          <span style={isMenuOpen ? { opacity: 0 } : undefined} />
          <span style={isMenuOpen ? { transform: "translateY(-6px) rotate(-45deg)" } : undefined} />
        </BurgerButton>
      </HeaderInner>
      <MobileNavPanel $open={isMenuOpen} aria-label="Мобільне меню">
        <MobileNavLink to="/">Home</MobileNavLink>
        {showWarehouse && <MobileNavLink to="/warehouse">Склад</MobileNavLink>}
        {showShipments && <MobileNavLink to="/shipments">Відправлення</MobileNavLink>}
        {showPhoneExpenses && <MobileNavLink to="/phone-expenses">Связь</MobileNavLink>}
        {showPayments && <MobileNavLink to="/payments">Платежі</MobileNavLink>}
        {showTelephony && <MobileNavLink to="/telephony">Продажі</MobileNavLink>}
        <div style={{ padding: '12px 24px' }}>
          <ThemeSelector />
        </div>
        <AuthBlock variant="menu" />
      </MobileNavPanel>
    </HeaderStyle>
  );
};

export default Header;
